var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransmission(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5625 18.8594L21.9925 20.9994",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35156 7V17",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7658 3.58579C22.5468 4.36684 22.5468 5.63317 21.7658 6.41422C20.9847 7.19527 19.7184 7.19527 18.9373 6.41422C18.1563 5.63317 18.1563 4.36684 18.9373 3.58579C19.7184 2.80474 20.9847 2.80474 21.7658 3.58579",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3516 7V10C20.3516 11.105 19.4566 12 18.3516 12H4.35156",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7658 3.58579C14.5468 4.36684 14.5468 5.63317 13.7658 6.41422C12.9847 7.19527 11.7184 7.19527 10.9373 6.41422C10.1563 5.63317 10.1563 4.36684 10.9373 3.58579C11.7184 2.80474 12.9847 2.80474 13.7658 3.58579",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76578 3.58579C6.54683 4.36684 6.54683 5.63317 5.76578 6.41422C4.98473 7.19527 3.7184 7.19527 2.93735 6.41422C2.1563 5.63317 2.1563 4.36684 2.93735 3.58579C3.7184 2.80474 4.98473 2.80474 5.76578 3.58579",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7658 17.5858C14.5468 18.3668 14.5468 19.6332 13.7658 20.4142C12.9847 21.1953 11.7184 21.1953 10.9373 20.4142C10.1563 19.6332 10.1563 18.3668 10.9373 17.5858C11.7184 16.8047 12.9847 16.8047 13.7658 17.5858",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76578 17.5858C6.54683 18.3668 6.54683 19.6332 5.76578 20.4142C4.98473 21.1953 3.7184 21.1953 2.93735 20.4142C2.1563 19.6332 2.1563 18.3668 2.93735 17.5858C3.7184 16.8047 4.98473 16.8047 5.76578 17.5858",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3516 7V17",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4219 18.859H20.5609C21.3499 18.859 21.9909 18.218 21.9909 17.429C21.9909 16.64 21.3499 16 20.5609 16H18.4219V16.004V21",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransmission);
export default __webpack_public_path__ + "static/media/transmission.82bd50bd72cedb2d9b17505bd1f3623d.svg";
export { ForwardRef as ReactComponent };